module.exports = __webpack_public_path__ + "static/media/stedman-for-senate-addresses-senate-cropped.59fab793.png";